<template>
    <div>
      <DashShellComponent
    :has-data="!!selectedService"
    :tabs="invoiceTabs"
  >
    <!-- Slot for Selection Pane -->
    <template #selection-pane>
      <SelectionPane 
        :fileFormatter="formatServices" 
        @selected="handleSelection" 
        @add-to-ledger="handleNewEntry" 
        @context-changed="getSelectedContext"
      />
    </template>

    <!-- Slot for Header -->
    <template #header-content>
      <HeaderAndContent 
        :selectedInvoice="selectedService" 
        :selectedClient="selectedClient" 
        :selectedQuote="selectedQuote" 
      />
    </template>
  </DashShellComponent>
    </div>
</template>

<script>
import axios from "@/plugins/axios"
import companiesJs from "@/plugins/companies"
import helpersJs from "@/plugins/helpers"
import AutoServiceCard from "./AutoServiceCard.vue"
import AutoServiceDetailHeader from "./AutoServiceDetailHeader.vue"
import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue"
import BillingTimer from '@/modules/CaseManager/BillingTimer.vue';
import BillingItemsTable from "@/modules/CaseManager/BillingItemsTable.vue";
import ClientManager from "@/modules/Clients/ClientManager.vue"
import WelcomeNotice from "@/components/General/WelcomeNotice.vue"
import InvoicePageHeader from "@/modules/InvoicesAndQuotes/InvoicePageHeader.vue"
import CaseDocumentsManager from "@/modules/CaseManager/CaseDocumentsManager.vue";
import CaseChronology from "@/modules/CaseManager/CaseChronology.vue";
import TrustAccountLedger from "@/modules/TrustAccount/TrustAccountLedger.vue"
import RepairAi from "./RepairAi.vue";
import Quotations from "@/modules/InvoicesAndQuotes/Quotations.vue";
import SelectionPane from "@/components/General/SelectionPane.vue";
import HeaderAndContent from "@/components/General/HeaderAndContent.vue"
import DashShellComponent from "@/components/General/DashShellComponent.vue";

export default {
    computed:{
        isMobile(){
            return this.$store.getters.isMobile
        },
        getAuthenticated(){
            return this.$store.getters.getAuthenticated
        },
        getTertiaryColor(){
            return this.$store.getters.getTertiaryColor
        },
        getAccessToken(){
          return this.$store.getters.getAccessToken
        },
        getTrustAccLabel(){
          return this.$store.getters.getTrustAccLabel
        },
        invoiceTabs() {
            if (!this.selectedService) return [];

            return [
              {
                label: '3. Billing & Expenses',
                mobileLabel: '3. Billing',
                icon: 'mdi-cash-register',
                component: BillingItemsTable,
                props: {
                  selectedInvoice: this.selectedService,
                  itemLabel: 'Invoice',
                  referenceNumber: 'invoice_number'
                },
                on: {
                  'billing-added': this.refreshBillingEntries
                }
              },
              {
                label: `4. ${this.getTrustAccLabel} Account`,
                mobileLabel: '4. Account',
                icon: 'mdi-bank-outline',
                component: TrustAccountLedger,
                props: {
                  scope: 'case',
                  reference: this.selectedService.card_number
                }
              },
              {
                label: '5. Job Card Details',
                mobileLabel: '5. Job Card',
                icon: 'mdi-folder-account',
                component: AutoServiceCard,
                props: {
                  selectedAutoService: this.selectedService,
                },
               
              },
              {
                label: "6. Service Ai",
                mobileLabel: "6. Service Ai",
                icon: "mdi-file-document-multiple",
                component: RepairAi,
                props:{
                  data: this.selectedService
                }
              },
              {
                label: '7. Activities & Tasks',
                mobileLabel: '7. Tasks',
                icon: 'mdi-format-list-checks',
                component: CaseChronology,
                props: {
                  caseData: this.selectedService
                }
              },
            ];
          }
    },
    components:{
    AutoServiceCard,
    AutoServiceDetailHeader,
    AutoCompleteCrudAdvanced,
    BillingTimer,
    ClientManager,
    WelcomeNotice,
    InvoicePageHeader,
    BillingItemsTable, CaseDocumentsManager, CaseChronology, TrustAccountLedger,
    RepairAi, Quotations,SelectionPane,
    HeaderAndContent,
    DashShellComponent
},
    data: () => ({
        activeTab:null,
        principalItemLabel:"Service Card",
        selectedContext: null,
        selectedService: null,
        selectedClient: null,
        selectedQuote: null,
        quotations: []
    }),
    async mounted(){
        this.initialiseComponent()
    },
    methods:{
        async initialiseComponent(){
          if(!this.getAuthenticated){
            return;
          }
            const userCompany = await companiesJs.getUserCompany()
            helpersJs.initialiseOrUpdateCompanyDataInStorage(null, userCompany)
            //this.$store.dispatch("getAllServiceCards",{fresh: true})
        },
        getSelectedContext(){
          this.selectedService = null
          this.selectedClient = null
          this.selectedQuote = null
        },
        handleSelection(selection){
          if(!selection) return;
          const category = selection.category
          const selectedItem = selection.data
          this.selectedContext = true;

            if(category === 'primary'){
              this.getSelectedService(selectedItem)
            }else if(category === 'client'){
              this.getSelectedClient(selectedItem)
            }else{ //its a quote
              this.getSelectedQuote(selectedItem)
            }
        },
        getSelectedService(service){
            this.selectedClient = null;
            this.selectedQuote = null
            this.selectedService = service;
        },
        formatQuotes({quotes}){
            if(!quotes || !quotes.length) return []
            const quotations = [];
            
            quotes.forEach(quote => {
                quotations.push({
                        ...quote,
                        name: `${quote.client?.name} | ${quote.quote_number}`
                    })
            });
            this.quotations = quotations
            return quotations;
        },
        getSelectedQuote(quote){
          this.selectedClient = null
          this.selectedService = null
          this.selectedQuote = quote
        },
        getSelectedClient(selectedClient){
            this.selectedService = null
            this.selectedQuote = null
            this.selectedClient = selectedClient
        },
        refreshDocs(docs){
          this.selectedService.documents = docs
        },
          //not done
      getAndSetConvertedInvoice(convertedInvoice){
        this.selectedClient = null;
        this.selectedQuote = null;
        this.selectedService = convertedInvoice;
      },
          //done
          refreshBillingEntries(billingEntries) {
          this.selectedService.billingEntries = billingEntries
        },
        handleNewEntry(newEntry) {
        this.selectedService.billingEntries.push(newEntry);
        
        this.$store.commit('setLoader',true)

        axios.postDataWithToken("/auth/save-or-update-case-billings",{
          internalRef:this.selectedService.card_number,
          invoiceNo: this.selectedService.invoice_number,
          billingEntries: this.selectedService.billingEntries
        },
        this.getAccessToken)
        .then(res => {
          this.$store.commit('setLoader',false)
          if(res && res.status == "success"){
            this.$toast.success("Billing entry added successfuly!",{duration:10000})
            this.selectedService.billingEntries = res.billingEntries
          }else{
            this.$toast.error('Oops, something went wrong!',{duration:10000})
          }
        })
        },
        formatServices({services}){
                    if(!services || !services.length) return []
                    const formattedServices = [];

                    services.forEach(service => {
                        formattedServices.push({
                            ...service,
                            name: `${service.client?.name} | ${service.card_number}`
                        })
                    });
                    this.$store.commit('setAllAutoServices',formattedServices)
                    return formattedServices;
                },
            }
}
</script>